export function edit_link(state = {}, action) {
  if (action.type === 'editlink') {
    return action.link;
  }
  return state;
}
